<template>
  <div>
    <template>  <!-- v-if="!isLoading -->
        <v-container class="grey lighten-5">
          <v-row no-gutters>
            <v-col cols="12" sm="6" md="8">
              <v-card class="pa-2" outlined tile>
            TEST          
            </v-card>
            </v-col>
            <v-col cols="6" md="4">
              <!-- <v-card class="pa-2" outlined tile>
                <div class="prodInfo">
                  <h1>Products on sale</h1>
                  <section v-if="errored">
                    <p>
                      We are sorry, we are not able to retrieve this information
                      at the moment. Please try back later.
                    </p>
                  </section>
                  <section v-else>
                    <div v-if="loading">Loading...</div>
                    <div v-else>
                      <table>
                        <thead>
                          <tr>
                            <th>Product Name</th>
                            <th>Price</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="prodInfo in prodInfo"
                            class="info"
                            v-bind:key="prodInfo"
                          >
                            <td>
                              {{ prodInfo.name }}
                            </td>
                            <td>
                              {{ prodInfo.price }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </section>
                </div>
              </v-card> -->
            </v-col>
          </v-row>
        </v-container>
    </template>
    <!-- <p v-else>
      Loading products
    </p> -->
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      isLoading: true,
      products: [],
      prodInfo: null,
      loading: true,
      errored: false
    }
  }
}
</script>

<style lang="scss" scoped></style>
